export { useClickArticleNotificationMutation } from "components/NewsStripe/hooks/useClickArticleNotificationMutation";
